import { MessageSquare, Palette, Calendar, Gamepad2, Music, TrendingUp, type LucideIcon } from 'lucide-react';

export interface RecursoNavItem {
  slug: string;
  icon: LucideIcon;
  accent: 'primary' | 'warm';
  /** Nome usado no dropdown do nav e no título/pílula da página do recurso. */
  label: string;
  /** Uma linha — usada como subtítulo no dropdown do nav. */
  tagline: string;
}

// Lista central usada pelo dropdown "Recursos" do nav — cada item leva
// direto para a página própria daquele recurso (src/pages/recursos/*.tsx).
export const recursos: RecursoNavItem[] = [
  {
    slug: 'comunicacao',
    icon: MessageSquare,
    accent: 'primary',
    label: 'Comunicação Alternativa (CAA)',
    tagline: 'Cartões visuais organizados por categoria, com voz natural ao toque.',
  },
  {
    slug: 'desenho-ia',
    icon: Palette,
    accent: 'warm',
    label: 'Desenho com IA',
    tagline: 'Reconhecimento de letras e números com inteligência artificial, em tempo real.',
  },
  {
    slug: 'rotinas',
    icon: Calendar,
    accent: 'primary',
    label: 'Rotinas e Alarmes',
    tagline: 'Checklists visuais e alarmes reais para cada etapa da rotina.',
  },
  {
    slug: 'jogos',
    icon: Gamepad2,
    accent: 'warm',
    label: 'Jogos Sociais',
    tagline: '9 jogos com situações do dia a dia para treinar habilidades sociais.',
  },
  {
    slug: 'musica',
    icon: Music,
    accent: 'primary',
    label: 'Música Terapêutica',
    tagline: 'Composições com IA organizadas por gênero, para relaxar, focar ou se divertir.',
  },
  {
    slug: 'progresso',
    icon: TrendingUp,
    accent: 'warm',
    label: 'Acompanhamento de Progresso',
    tagline: 'Um painel único reúne o que a criança mais usa em cada módulo.',
  },
];
